<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';

import CVBanner from 'JIX/components/CVBanner.vue';
import JobsearchResultList from './JobsearchResultList.vue';
import SkyscraperIframe from 'JIX/components/SkyscraperIframe.vue';

const store = useStore();

const site = ref(window.Stash.common.site);
</script>

<template>
    <section class="container">
        <div class="row justify-content-center mb-5">
            <JobsearchResultList class="col-lg-6 col-md-8" />
            <div class="col-2 d-none d-lg-block">
                <SkyscraperIframe
                    v-if="store.state.searchResponse.skyscraper"
                    :url="$store.state.searchResponse.skyscraper.url"
                    :height="$store.state.searchResponse.skyscraper.default_height"
                    :width="$store.state.searchResponse.skyscraper.default_width"
                />
            </div>
        </div>
        <div class="row" v-if="site !== 'jobdk' && !store.state.hasCv && (store.state.searchQuery.page ?? 1) === 1">
            <div class="offset-md-2 col-lg-6 col-md-8">
                <CVBanner
                    :cv-url="store.state.urls.cv_default + '?source=jobsearch'"
                />
            </div>
        </div>
    </section>
</template>
